import { Base } from '@app/shared/models/base.model'
import { User } from '@app/modules/user/user.model'
import { TelephoneName } from '@app/modules/telephone-name/telephone-name.model'

export class Telephone extends Base {
  uuid: string = null
  telephoneNameUuid: string = null
  number: string = null
  extension: string = null
  iso2: string = null
  // ---------------------------------------------------------------------------
  createdAt: Date = null
  updatedAt: Date = null
  deletedAt: Date = null
  createdByUuid: string = null
  createdByUser: User = null
  updatedByUuid: string = null
  updatedByUser: User = null
  // Relations.
  telephoneName: TelephoneName = null

  /**
   * Properties with type Date
   *
   * @type {Array<string>}
   */
  protected _dates: Array<string> = [
    'createdAt',
    'updatedAt',
    'deletedAt'
  ]

  /**
   * Constructor
   *
   * @param {Partial<Telephone>} data Initial values
   */
  public constructor (data?: Partial<Telephone>) {
    super(data)
    this.init(data)
  }
}
